<template>
  <div></div>
</template>
<script>
// import store from "@/store/index";
export default {
  name: "TimerPrice",
  props: {
    active: Number,
    title: Boolean,
    fulid: Boolean,
    setting: Boolean,
    activeSetting: Number,
  },
  mounted() {},
  created() {
    let _that = this;
    _that.$store.commit("setCommonPrice", "");
    setInterval(_that.$store.commit("setCommonPrice", ""), 6000);
  },
  mutations() {},
};
</script>
